<template>
<div>
    <div class="reservations">
	<div class="container">
		<div class="row justify-content-center">
			<div class="col-md-12">
			<div class="card">
				<div class="card-header bg-white border-0">
					<div class="row align-items-center">
						<div class="col-8">
							<h3 class="mb-0 text-left">{{$t("forms.reservation.reservation")}} {{reservation.customerId}}</h3>
						</div>
                        <div class="col-4 text-right">
                            <button v-if="isAuthenticated" class="btn btn-sm btn-primary" @click="goToMyBookings" replace :to="{ name: 'reservations' }">
                                {{$t('forms.reservation.myReservations')}}
                            </button>
                            <router-link class="btn btn-sm btn-success ml-3" replace to="/">{{$t('actions.newBooking')}}</router-link>
                        </div>
					</div>
					<hr>
				</div>
                <div class="card-body">
                    <div v-show="isLoading">
                        <div class="spinner-border text-warning" role="status"><span class="sr-only">{{$t('actions.loading')}}</span></div>
                    </div>
                    <div v-show="!isLoading">
                        <div class="mb-5" v-for="reservation in reservation.bookings" :key="reservation.guid">
                            <div class="row"><div class="col-12"><h3 class="text-left"><u>Booking: {{reservation.customerId}}</u></h3></div></div>
                        <div class="row" >
                            <div class="item-row col-4">
                                <div class="text-left">
                                    <b>{{$t("forms.reservation.pickupPointLabel")}}:</b> {{reservation.from.address}}
                                </div>
                                <div class="text-left" v-show="reservation.from.address != reservation.from.addressName">
                                    <b>{{$t("forms.reservation.pickupAddressLabel")}}:</b> {{reservation.from.addressName}}
                                </div>
                                 <div class="text-left">
                                    <b>{{$t("forms.reservation.pickupDateLabel")}}:</b> {{reservation.pickupDateString}} <br>
                                    <b>{{$t("forms.reservation.pickupTimeLabel")}}:</b> {{reservation.pickupTimeString}}
                                </div>
                            </div>
                            <div class="item-row col-4">
                                 <div class="text-left" v-show="reservation.bookingType !== 2">
                                    <div>
                                        <b>Drop-off point:</b> {{reservation.to.addressName}}
                                    </div>
                                    <div v-show="reservation.to.addressName != reservation.to.address">
                                        <b>Drop-off address:</b> {{reservation.to.address}}
                                    </div>
                                </div>
                                <div class="text-left" v-show="reservation.bookingType === 2">
                                    <span class="item-details"> <b>Booked for:</b> {{reservation.durationInHours}} hours</span>
                                </div>                                
                                <div class="text-left" v-show="reservation.numberOfCars > 0 && isDrivano()">
                                    <b>Drivers:</b> {{reservation.numberOfCars}}
                                </div>                               
                            </div>
                            <div class="item-row col-4">
                                <ul v-if="reservation.extras && reservation.extras.length > 0" class="list-unstyled mb-1">
                                   <li class="d-flex justify-content-between" v-for="(item) in reservation.extras" :key="item.guid">
                                       <span class="text-left">{{item.description}}</span> 
                                       <span class="text-right no-break">{{item.companyAmount | round(2, true)}} {{reservation.currencyCode}}</span>
                                    </li>
                               </ul>
                               <div class="d-flex justify-content-between" v-show="reservation.totalPrice > 0">
                                    <span><b>{{$t("forms.reservation.tripPriceLabel")}}:</b></span>
                                    <span>{{reservation.price | round(2, true)}} {{reservation.currency}}</span>                                    
                               </div>
                               <hr/>
                               <div class="d-flex justify-content-between" v-show="reservation.totalPrice > 0">
                                    <span><b>{{$t("forms.reservation.totalPriceLabel")}}:</b></span>
                                    <span>{{reservation.totalPrice | round(2, true)}} {{reservation.currency}}</span>                                    
                               </div>
                               <div class="text-left" v-if="reservation.paymentMethod">
                                    <b v-if="reservation.paymentMethod != 'Cash'">
                                        {{$t("forms.reservation.paidByLabel")}} {{$t(`common.paymentMethods.${reservation.paymentMethod.toLowerCase()}`)}}
                                    </b>
                                     <b class="text-warning" v-if="reservation.paymentMethod == 'Cash'">
                                        {{$t("forms.reservation.payToDriver")}} {{$t(`common.paymentMethods.${reservation.paymentMethod.toLowerCase()}`)}}
                                    </b>
                               </div>
                            </div>
                        </div>
                        </div>
                
                        <div class="row" v-show="(reservation.state == 0 || reservation.state == 1) && reservation.paymnetStatus === 3 && reservation.paymentMethod == 'Card'">
                            <div class="col-12 text-center m-b-xs m-t-xs">
                                <h3 class="text-success"><i class="fa fa-check"></i>{{$t("forms.reservation.reservationIsConfirmed")}}</h3>
                                <h5 v-show="reservation.driverAcceptanceStatus < 3">
                                    {{$t("forms.reservation.lookingForAdriver")}}
                                </h5>
                            </div>
                        </div>

                        <div class="row" v-show="(reservation.paymnetStatus === 1 || reservation.paymnetStatus === 5)  && reservation.clientPaymentUrl">
                            <div class="col-sm-12 text-center m-b-md m-t-lg">
                                <a class="btn btn-green m-b-md" :href="reservation.clientPaymentUrl">
                                    <i class="fa fa-credit-card"></i> {{$t("actions.confirmByCard")}}
                                </a>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-sm-12 text-center mt-4" v-show="reservation.state == 3">
                                <h3 class="text-success">Booking is finished</h3>
                                <!-- Rate --> 
                            </div>
                        </div>

                        <div class="row mb-4" v-if="reservation.canCancel && reservation.state !== 4">
                            <div class="col-sm-12 text-center mt-3">
                                <button @click="goToCancelBooking" class="btn btn-danger">{{$t("actions.cancelReservation")}}</button>
                            </div>
                            <div class="col-sm-12 text-center m-b-md" v-if="reservation.freeCancellationTillMoment">
                                Free cancellation till {{reservation.freeCancellationTill.format('dddd, DD MMM YYYY @ hh:mm')}}
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12 text-center" v-show="reservation.state == 4">
                                <h3 class="text-danger">{{$t("forms.reservation.reservationIsCancelled")}}</h3>
                            </div>
                        </div>                        
                        <div class="row">
                            <div class="col-sm-12 text-center m-b-md" v-show="reservation.driverStatus === 3">
                                <h5 class="text-success font-bold">Your chauffeur arrived at meeting point.</h5>
                                <a href="tel:" class="btn btn-success"> <i class="fa fa-phone"></i>
                                    {{reservation.driverPhone}}</a>
                                <br />
                                <h6 class="m-t-lg" v-show="reservation.driverLocation">
                                    Your chauffeur location is display on the map below
                                </h6>                                                               
                            </div>
                        </div>
                        <div class="row" v-show="mapModel.visible">
                            <div class="col-12">
                                <google-map id="bookingMap" style="min-height: 300px;" 
                                    v-show="mapModel.visible"
                                    :map-visibility="mapModel.visible"
                                    :map-model="mapModel" :map-center="mapModel.mapCenter">
                                </google-map>
                            </div>
                        </div> 
                    </div>
                </div>
			</div>
            </div>
        </div>
	</div>    
    </div>
</div>
</template>

<script>
import { mapActions } from "vuex";
import { round } from "../utils/filters.js";
import moment from 'moment';
import GoogleMap from "./../components/vue-google-map/vue-google-map.vue";
import Api from './../services/apiService.js';

export default {
    data() {
        return {
            isLoading: true,
            myBookingsLink: "history",
            reservation: {
                from: {},
                to: {},
                canCancel: false
            },
        };
    },
    components: {
        GoogleMap
    },
    computed: {
        isAuthenticated: function(){
            return this.$store.state.account.isLoggedIn;
        },
        mapModel: function () {
            if(!this.reservation || !this.reservation.from.latLng) return { mapCenter: {}, visible: false };
            let center = this.reservation.from.latLng;
            let label = null;
            let zoom = 13;
            if(this.reservation.driverLocation){
                center = {
                    lat: this.reservation.driverLocation.lat,
                    lng: this.reservation.driverLocation.lng
                };
                label = "Your Chauffeur";
                zoom = 16;
            }
            let result = 
            {
                from: {
                    latLng: center
                },
                mapCenter: center,
                zoom: zoom,           
                markerLabel: label,
                bookingType: 2, //must have hourly booking to put map pointer
                visible: true
            }
            return result;
        },
    },
    filters: {
        round: round
    },
    created() {
        if(this.$route.params.id){
            this.loadBookingFromGuid(this.$route.params.id);
        }
        if(this.$route.params.hash){
            this.loadBookingFromHash(this.$route.params.hash);
        }
    },
    beforeRouteEnter (to, from, next) {
        next(vm => {
            if(from.name != "reservations"){
                vm.myBookingsLink = "route";
            }
        });
    },
    methods: {
        isDrivano: function () {
            return this.$store.state.booking.configuration.isDrivano;
        },
        loadBookingFromGuid: function(guid) {
            this.getReservationDetails(guid).then(result=>{
                console.log("getClientReservations result:", result);
                this.reservation = result;
                this.reservation.freeCancellationTill = moment(this.reservation.freeCancellationTillMoment, "DD-MM-YYYY HH:mm A");
                console.log(this.reservation.freeCancellationTill)
                this.isLoading = false;
            });
        },
        loadBookingFromHash: function(hash) {
            Api.getReservationDetailsUsingHash(hash).then(response => {
                let result = response.data.result;
                console.log("getClientReservations result:", result);
                this.reservation = result;
                this.reservation.freeCancellationTill = moment(this.reservation.freeCancellationTillMoment, "DD-MM-YYYY HH:mm A");
                console.log(this.reservation.freeCancellationTill)
                this.isLoading = false;
            });
        },
        goToMyBookings: function(){
            if(this.myBookingsLink == "history"){
                this.$router.go(-1);
            }
            else {
                this.$router.replace({name: "reservations"});
            }
        },  
        goToCancelBooking: function(){
            this.$router.push({name: 'cancelReservation', params: {id: this.reservation.hash}});
        },   
        ...mapActions("account", ["getReservationDetails"]),
    }
}
</script>

<style>
#bookingMap { margin-top: 30px;}
.no-break {
    white-space: nowrap;
    word-break: keep-all;
}
</style>
